module.exports = __webpack_public_path__ + "img/Keeney.4cd3051c.jpeg";